import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { RoutePath } from "src/app/config/routing.config";
import { AuthService } from "src/app/services/auth.service";

/**
 * AuthGuard which checks if the user is logged in before accessing a protected route.
 */
@Injectable()
export class AuthGuard implements CanActivate {
	constructor(
		private readonly authService: AuthService,
		private readonly router: Router,
	) {}

	public canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
		return this.authService.IsUserLoggedIn$.pipe(
			tap((isUserLoggedIn) => {
				if (!isUserLoggedIn) {
					const url: string = state.url;
					const splitted: string[] = url.split("/").filter((urlSegment) => urlSegment);
					if (splitted.length == 2 && splitted[0] == RoutePath.List) {
						const assetId = splitted[1];
						this.router.navigate([`/${RoutePath.Login}/${assetId}`]);
					} else {
						this.router.navigate([`/${RoutePath.Login}`]);
					}
				}
			}),
		);
	}
}
